import {OfferType} from "@pg-rp/common-types";

import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {SearchSort} from "../../offer/list/constants/SearchSort";
import {VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE} from "../constants/vendor_detail_offers_max_page_size";
import {VendorDetailSoldOffersPageSize} from "../constants/VendorDetailSoldOffersPageSize";
import {VendorDetailUnavailableOffersPageSize} from "../constants/VendorDetailUnavailableOffersPageSize";
import {convertToVendorDetailViewOffersPayload} from "./convert_to_vendor_detail_view_offers_payload";

export function buildVendorDetailAllOffersParams(params: {vendorId: number; region: number | null; type?: OfferType | null; sort?: SearchSort; page?: number}) {
    return {
        ...convertToVendorDetailViewOffersPayload({
            vendorId: params.vendorId,
            region: params.region,
            displayType: [OfferDisplayType.FOR_SALE, OfferDisplayType.ON_HOLD],
            type: params.type ?? undefined,
            sort: ["active_hold_archived", params.sort ?? SearchSort.DEFAULT],
            pageSize: VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE
        }),
        limited_presentation: undefined,
        is_active: undefined,
        page: params.page ?? 1
    };
}

export function buildVendorDetailOfferListMapParams(params: {vendorId: number; region: number | null}) {
    return {vendor: params.vendorId, region: params.region};
}

export function buildVendorDetailSoldOffersParams(params: {vendorId: number; region: number | null; page?: number}) {
    return {
        ...convertToVendorDetailViewOffersPayload({
            vendorId: params.vendorId,
            region: params.region,
            displayType: OfferDisplayType.SOLD,
            pageSize: VendorDetailSoldOffersPageSize,
            type: [OfferType.FLAT, OfferType.HOUSE]
        }),
        limited_presentation: undefined,
        page: params.page ?? 1
    };
}

export function buildVendorDetailInactiveOffersParams(params: {vendorId: number; region: number | null; page?: number}) {
    return {
        ...convertToVendorDetailViewOffersPayload({
            vendorId: params.vendorId,
            region: params.region,
            displayType: [OfferDisplayType.FOR_SALE, OfferDisplayType.ON_HOLD],
            pageSize: VendorDetailUnavailableOffersPageSize,
            type: [OfferType.FLAT, OfferType.HOUSE]
        }),
        limited_presentation: true,
        is_active: undefined,
        page: params.page ?? 1
    };
}
import {OfferType} from "@pg-rp/common-types";

import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {SearchSort} from "../../offer/list/constants/SearchSort";
import {VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE} from "../constants/vendor_detail_offers_max_page_size";
import {VendorDetailSoldOffersPageSize} from "../constants/VendorDetailSoldOffersPageSize";
import {VendorDetailUnavailableOffersPageSize} from "../constants/VendorDetailUnavailableOffersPageSize";
import {convertToVendorDetailViewOffersPayload} from "./convert_to_vendor_detail_view_offers_payload";

export function buildVendorDetailAllOffersParams(params: {vendorId: number; region: number | null; type?: OfferType | null; sort?: SearchSort; page?: number}) {
    return {
        ...convertToVendorDetailViewOffersPayload({
            vendorId: params.vendorId,
            region: params.region,
            displayType: [OfferDisplayType.FOR_SALE, OfferDisplayType.ON_HOLD],
            type: params.type ?? undefined,
            sort: ["active_hold_archived", params.sort ?? SearchSort.DEFAULT],
            pageSize: VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE
        }),
        limited_presentation: undefined,
        is_active: undefined,
        page: params.page ?? 1
    };
}

export function buildVendorDetailOfferListMapParams(params: {vendorId: number; region: number | null}) {
    return {vendor: params.vendorId, region: params.region};
}

export function buildVendorDetailSoldOffersParams(params: {vendorId: number; region: number | null; page?: number}) {
    return {
        ...convertToVendorDetailViewOffersPayload({
            vendorId: params.vendorId,
            region: params.region,
            displayType: OfferDisplayType.SOLD,
            pageSize: VendorDetailSoldOffersPageSize,
            type: [OfferType.FLAT, OfferType.HOUSE]
        }),
        limited_presentation: undefined,
        page: params.page ?? 1
    };
}

export function buildVendorDetailInactiveOffersParams(params: {vendorId: number; region: number | null; page?: number}) {
    return {
        ...convertToVendorDetailViewOffersPayload({
            vendorId: params.vendorId,
            region: params.region,
            displayType: [OfferDisplayType.FOR_SALE, OfferDisplayType.ON_HOLD],
            pageSize: VendorDetailUnavailableOffersPageSize,
            type: [OfferType.FLAT, OfferType.HOUSE]
        }),
        limited_presentation: true,
        is_active: undefined,
        page: params.page ?? 1
    };
}
